export function init() {
  const freeDigitalCopyForms = document.querySelectorAll("form.homepage__free-digital-copy--form");
  for (let i = 0; i < freeDigitalCopyForms.length; i++){
    setEvents(freeDigitalCopyForms[i]);
  }
}

function setEvents(form){
  form.addEventListener("submit", controlRequirements)
  const checkboxes = form.querySelectorAll('input[type="checkbox"]');
  for (let i = 0; i < checkboxes.length; i++) {
    checkboxes[i].addEventListener("change", event => {
      toggleCheckbox(event, form)
    });
  }
}

function controlRequirements(event){
  const form = event.target;
  // It will only work for ONE checkbox
  const checkbox = form.querySelector('input[type="checkbox"]');
  const label = form.querySelector('label.homepage__free-digital-copy--checkbox');
  event.preventDefault();
  if (checkbox.checked) {
    form.submit();
  } else {
    label.classList.add('homepage__free-digital-copy--error');
  }
}

function toggleCheckbox(event, form) {
  const checkbox = event.target;
  const dot = form.querySelector(".icon-dot");
  const label = form.querySelector('label.homepage__free-digital-copy--checkbox');
  if (checkbox.checked) {
    dot.classList.remove("icon-dot__empty");
    label.classList.remove('homepage__free-digital-copy--error');
  } else {
    dot.classList.add("icon-dot__empty");

  }
}



// WEBPACK FOOTER //
// ./scripts/components/FreeDigitalCopy.js